import { composeRefs } from "@lilib/utils";
import usePersist from "./usePersist";
function useComposedRef() {
  return usePersist(composeRefs.apply(void 0, arguments));
}
export default useComposedRef;